import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyActionService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
    statisticSummary,
};

const MODULE = {
    PROPERTY_ACTION: 'property-actions',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_ACTION}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        description: data.description,
    };

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY_ACTION}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_ACTION}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        description: data.description,
    };

    return apiHelper(API_URL).put(`/${MODULE.PROPERTY_ACTION}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_ACTION}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_ACTION}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY_ACTION}/${data.uuid}`);
}

export function statisticSummary () {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_ACTION}/statistic-summaries`);
}
